import React, { useState, useEffect } from 'react';
import { Layout, Menu } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { HomeOutlined, BankOutlined } from '@ant-design/icons';
import { DashboardContainer, SidebarContent, MainContent, Logo } from './styled';

const { Sider, Content } = Layout;

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Initialize collapsed state as true (closed by default)
  const [collapsed, setCollapsed] = useState(true);

  // Ensure sidebar starts collapsed on component mount
  useEffect(() => {
    setCollapsed(true);
  }, []);

  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: 'Home',
      onClick: () => navigate('/')
    },
    {
      key: '/commissions',
      icon: <BankOutlined />,
      label: 'Commissions',
      onClick: () => navigate('/commissions')
    }
  ];

  return (
    <DashboardContainer>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          width={250}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          trigger={null}
          collapsedWidth={80}
          style={{
            background: '#fff',
            borderRight: '1px solid #f0f0f0'
          }}
        >
          <SidebarContent>
            <Logo>
              <h2>Home Matters</h2>
            </Logo>
            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              items={menuItems}
              style={{ border: 'none' }}
            />
          </SidebarContent>
        </Sider>
        <Layout>
          <Content>
            <MainContent>
              <Outlet />
            </MainContent>
          </Content>
        </Layout>
      </Layout>
    </DashboardContainer>
  );
};

export default DashboardLayout;
